module.exports = __webpack_public_path__ + "static/media/404_computer.56871168.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/svg/404_computer.svg
// module id = 942
// module chunks = 0